import { GET_LOCALIZATION_REQUEST } from './constants';

export const getResourceBundle = () => ({
  type: GET_LOCALIZATION_REQUEST
});
